import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Rede de segurança da tela "Conferindo…" (story 8.3a).
//
// O caminho normal é o Action Cable: o job vigia faz o broadcast do resultado e a tela troca o bloco
// sozinha, em segundos. Mas o broadcast é ÚNICO e não tem replay: se a transição de status cair entre
// o render da página e a inscrição do canal (redirect pós-POST + motor rápido), ou se o cabo estiver
// reconectando (laptop dormiu), a página fica presa sem nenhum fallback. Este controller recarrega a
// página uma vez depois de `recarregarEm` segundos enquanto a conferência estiver em andamento — o
// suficiente para o caso raro, sem virar o F5 automático de 5s que o review mandou remover.
//
// Data attributes esperados:
//   data-controller="conferencia"
//   data-conferencia-recarregar-em-value="60"   (segundos; default 60)
export default class extends Controller {
  static values = { recarregarEm: { type: Number, default: 60 } }

  connect() {
    this.timer = setTimeout(() => {
      Turbo.visit(window.location.href, { action: "replace" })
    }, this.recarregarEmValue * 1000)
  }

  disconnect() {
    // O broadcast trocou o bloco (e este elemento saiu do DOM): nada a recarregar.
    clearTimeout(this.timer)
  }
}
